import {
    Grid,
    Container,
    IconButton,
    Typography
} from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import CallIcon from '@material-ui/icons/Call';
import {Helmet} from "react-helmet";

const useStyles = makeStyles({
    contactSection: {
        marginTop: '50px'
    },
    image: {
        width: '100%'
    },
    contactHeading: {
        color: '#005cbf',
        fontFamily: "Helvetica Neue",
    },
    icons: {
        color: 'black',
        '&:hover': {
            backgroundColor: '#005cbf',
            color: 'whitesmoke'
        }
    }
})

function ContactUs() {
    const classes = useStyles();

    return (
        <>
        <Helmet>
        <title>Noon Yacht | Contact Us</title>
        <meta name="description" content="Noon Yacht is Dubai's Favorite Award Winning Yacht Rental Dubai Company, Book Online." />
        <meta name="keywords" content="Noon Yacht dubai,Noon Yacht,yachts,xclusive yachts,yachts in dubai marina,princess yachts,marina yachts,
        dubai marina yachts,luxury yachts,majesty yachts,azimut yachts,royal yachts,yachts dubai,luxurious yachts,
        yachts in dubai,yachts for rent,cozmo yachts,superyacht,boat charter,mega yacht,yacht charter,sailing yacht
        yacht broker,birthday parties on yachts,birthday yachts,birthday in yacht,happy birthday yachts,birthday party in yacht dubai,
        wedding yachts miami,wedding on a yacht dubai,wedding charter yachts,wedding yachts in miami,wedding yacht dubai,
        mega yachts dubai,mega yachts for charter,mega yachts and superyachts,fishing in dubai,fishing abu dhabiyachts rental dubai,yachts rental,yachts rental near me,yachts rental in miami,adonia yachts rental lake powell,
adonia yachts rental,ariel yachts rental,azimut yachts rental,a yacht rental,yachts rental miami beach,yachts and boats rental dubai,nanje rental yachts dubai,
yachts to rent in dubai,yacht rental uae,yachts for rental,yachts for rental near me,yachts for rental in miami,yachts for rental in dubai,
luxury yachts for rental,yachts rental in dubai,yachts rental in abu dhabi,yacht rent dubai,yacht charters dubai,luxury yachts rental,
yachts rental miami,luxury yachts rental miami,luxury yachts rental marina,mega yachts rental,yacht rent in abu dhabi,party yacht rental,yachts rentals,
yachts rentals near me,yachts rentals dubai,vacation rental yachts,wajer yachts rental,xclusive yachts rental dubai,yacht booking abu dhabi,yacht to rent dubai,
yachts dubai rent" />
    </Helmet>
        <Container className={classes.contactSection}>
            <Grid container spacing={4}>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <img className={classes.image} src="/images/new-images/contact-us.webp" alt="Noon Yacht" />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <Typography className={classes.contactHeading} variant='h2'>Contact Us</Typography>
                    <ul>
                    <li>
                    <a>
                    <IconButton className={classes.icons}
                    target="_blank"
                    href='https://www.facebook.com/habibiyachtsevents/'
                    >
                        <FacebookIcon />
                        @habibiyachtsevents
                        
                    </IconButton>
                    </a>
                    </li>
                    
                    <li>
                    <a>
                    <IconButton className={classes.icons}
                    target="_blank"
                    href='https://www.instagram.com/noon_yachts/'
                    >
                        <InstagramIcon />
                        @noon_yachts
                    </IconButton>
                    </a>
                    </li>
                    

                    <li>
                    <a>
                    <IconButton
                        target="_blank"
                        href='https://wa.me/+971567033102'
                        className={classes.icons}
                    >
                        <WhatsAppIcon />
                        +971567033102
                    </IconButton>
                    </a>
                    </li>
                    
                    <li>
                    <a>
                    <IconButton
                    className={classes.icons}
                    href="tel:+971567033102" >
                     <CallIcon />
                     +971567033102
                    </IconButton>
                     </a>
                    </li>
                    </ul>
                    <Typography className={classes.contactHeading} variant='h5'>Developer Contact</Typography>
                    <ul>
                    
                    <a>
                    <IconButton className={classes.icons}
                    target="_blank"
                    href='https://www.facebook.com/khubair.ali.739'
                    >
                        <FacebookIcon />                        
                    </IconButton>
                    </a>
                    
                    <a>
                    <IconButton className={classes.icons}
                    target="_blank"
                    href='https://www.instagram.com/khubair.ali/'
                    >
                        <InstagramIcon />
                    </IconButton>
                    </a>
                    
                    <a>
                    <IconButton
                        target="_blank"
                        href='https://wa.me/+923008186803'
                        className={classes.icons}
                    >
                        <WhatsAppIcon />
                    </IconButton>
                    </a>
                    
                    <a>
                    <IconButton
                    className={classes.icons}
                    href="tel:+923008186803" >
                     <CallIcon />
                    </IconButton>
                     </a>
                    </ul>
                </Grid>
            </Grid>
        </Container>
        </>
    )
}

export default ContactUs;
